<template lang="pug">
div
  form-header(
    v-if="data",
    ref="form-header",
    :parentData="{ title: `${data.form_header.title} № ${row.id}`, title_icon: 'show_header.svg' }"
  )

  div(v-for="(block, blockIndex) in printBlocks", :key="blockIndex", :class="`show-card-info ${block.class}`")
    .row-title(v-if="block.name", style="margin: 10px; font-size: 20px; font-weight: bold") {{ block.name }}
    .row-info-parts(v-for="(part, partIndex) in block.parts", :key="partIndex")
      .spacer(v-if="block.spacer")
      .row-info-field(v-for="field in part", :key="field.value", style="width: 100%")
        span.row-label {{ field.label }}
        span.row-value(v-if="field.type === 'description'", v-html="row[field.value]")
        span.row-value(v-else) {{ getFieldText(field) }}

  .issue-print-images(v-if="options.printImages")
    .issue-print-images__group(v-for="group in imageGroups", :key="group.key")
      h3 {{ group.label }}:
      .issue-print-images__file(v-for="file in group.files", :key="file.id || file.url")
        p {{ getPrintFileName(file) }}
        img(:src="file.url", :alt="getPrintFileName(file)")
</template>

<script setup>
import { computed } from "vue";
import formHeader from "../../../shared/forms/formHeader";
import { formatDateText } from "@/services/useDateTextFormatter";
import {
  isEmptyPrintValue,
  getIssuePrintBlocks,
  getPrintFiles,
  getPrintFileName,
  getIssuePrintImageGroups,
} from "@/services/useIssuePrint";

const props = defineProps({
  /*
  Основные данные

  Пример: { row: данные заявки, data: { form_header: поля хедера, blocks: блоки с данными } }
  */
  parentData: {
    type: Object,
    default: () => {},
  },
  options: { type: Object, default: () => ({ hideEmptyFields: false, printImages: false }) },
});

const row = computed(() => props.parentData.row);
const data = computed(() => props.parentData.data);
const printBlocks = computed(() => getIssuePrintBlocks(data.value?.blocks, row.value, props.options.hideEmptyFields));
const imageGroups = computed(() => getIssuePrintImageGroups(printBlocks.value, row.value));

const getFieldText = field => {
  const value = row.value[field.value];

  if (field.type === "file") {
    return getPrintFiles(value).map(getPrintFileName).filter(Boolean).join(", ") || "-";
  }

  return isEmptyPrintValue(value) ? "-" : formatDateText(value, "dd.MM.yyyy, HH:mm");
};
</script>
